import React from "react"
import { connectSortBy } from "react-instantsearch-dom"
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material"

interface SortConfig {
	defaultRefinement: string
	items: {
		value: string
		label: string
	}[]
}

const getSortConfig = (indexName: string) => {
	const [unsortedIndexName] = indexName.split("_")

	if (unsortedIndexName.includes("locking-systems")) {
		const sortConfig: SortConfig = {
			defaultRefinement: indexName,
			items: [
				{
					value: unsortedIndexName,
					label: "Relevanz",
				},
				{
					value: `${unsortedIndexName}_security_asc`,
					label: "Sicherheit aufsteigend",
				},
				{
					value: `${unsortedIndexName}_security_desc`,
					label: "Sicherheit absteigend",
				},
			],
		}

		return sortConfig
	}

	const sortConfig: SortConfig = {
		defaultRefinement: indexName,
		items: [
			{
				value: unsortedIndexName,
				label: "Relevanz",
			},
			{
				value: `${unsortedIndexName}_price_asc`,
				label: "Preis aufsteigend",
			},
			{
				value: `${unsortedIndexName}_price_desc`,
				label: "Preis absteigend",
			},
		],
	}

	return sortConfig
}

const SortResultsConsumer: React.ComponentClass<SortByExposed> = connectSortBy(
	function SortResultsConsumerChild({ items, currentRefinement, refine }: SortByProvided) {
		const onChange = (e: any) => refine(e.target.value)

		return (
			<FormControl variant="outlined" style={{ maxWidth: 200 }} fullWidth>
				<InputLabel id="select-sort-label" style={{ border: "none" }} />
				<Select
					labelId="sort-results"
					id="sort-results"
					value={currentRefinement}
					onChange={onChange}
					style={{
						border: "none",
						background: "white",
						borderRadius: 20,
						height: 38,
						width: 180,
					}}
				>
					{items.map((item) => {
						const { label, value } = item

						return (
							<MenuItem key={label} value={value}>
								{label}
							</MenuItem>
						)
					})}
				</Select>
			</FormControl>
		)
	},
)

interface SortByProvided {
	items: {
		label: string
		value: string
		isRefined: string
	}[]
	currentRefinement: string
	refine: (value: string) => void
}

interface SortByExposed {
	items: {
		label: string
		value: string
	}[]
	defaultRefinement: string
}

const SortResults = ({ indexName }: Props) => {
	const sortConfig = getSortConfig(indexName)

	return <SortResultsConsumer {...sortConfig} />
}

interface Props {
	indexName: string
}

export default SortResults
